import React from 'react';
import omit from 'lodash/omit';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';

import { env } from '../../config';
import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';

const api = '/api/core/users/admins';

const ListAdmins = (props) => {
  const { school } = props;

  return (
    <ListResource
      {...{
        searchable: true,
        api,
        sort: { 'name.full.en': 1 },
        filter: school
          ? { school, roles: 'schoolAdmin' }
          : { roles: 'admin' },
        cols: [
          { key: 'name.full.en', children: 'Name (English)', sortable: true },
          { key: 'name.full.zhhk', children: 'Name (Chinese)', sortable: true },
          {
            key: 'active',
            getter(v) {
              return (
                <FA icon={v ? faEye : faEyeSlash} />
              );
            },
          },
          { key: 'schoolClass.title', children: 'Class' },
          { key: 'email', sortable: true },
        ],
        ...omit(props, 'school'),
      }}
    >
      {({ selected, refresh }) => (
        <ListCtrlActivates
          api={api}
          selected={selected}
          isAdmin={env.user.roles.includes('admin')}
          onSuccess={refresh}
        />
      )}
    </ListResource>
  );
};

export default ListAdmins;
